import React, { useState } from "react";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import lenis from "../lenis";
import TermsConditions from "../components/TermsConditions";
import Modal from "../components/Modal";

function SignUpPage(){
    const[isTermsOpen, setIsTermsOpen] = useState(false);
    const {user, logout} = useAuth();
        const location = useLocation();
        const navigate = useNavigate();
    
        const handleScrollTo = (target) => {
            const scrollOptions = { offset: 0 }; // Definimos las opciones una sola vez
    
            if (location.pathname === '/') {
                lenis.scrollTo(target, scrollOptions);
            } else {
                // Pasamos tanto el ID como las opciones a la HomePage
                navigate('/', { state: { scrollToId: target, scrollOptions: scrollOptions } });
            }
        };

    const [formData, setFormData] = useState({
        nombre: '',
        apellido: '',
        email: '',
        cedula: '',
        password: '',
        telefono: '',
        aceptaTerminos: false,
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if(name === 'cedula'){
            const numericValue = value.replace(/[^0-9]/g, '');
            setFormData(prevState => ({
                ...prevState,
                [name]: numericValue,
            }));
        }else{
            setFormData(prevState => ({
                ...prevState,
                [name]: type === 'checkbox' ? checked : value
            })); 
        }
        
    };

    const handleClear = () =>{
        setFormData({
            nombre: '', apellido:'', email:'', cedula:'', password: '', telefono:'', aceptaTerminos: false,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if(formData.cedula.length !== 10){
            alert('La cedula debe contener exatamente 10 digitos.');
            return;
        }

        if(!formData.aceptaTerminos) {
            alert('Debes aceptar los terminos y condiciones.');
            return;
        }
        try{
            const response = await fetch('https://kifli-api.onrender.com/api/register', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (response.ok){
                alert(data.message);
                handleClear();
            } else {
                throw new Error(data.message);
            }
        } catch(error){
            console.error('Error en el registro:', error);
            alert(`Error: ${error.message}`);
        }
    };

    return(
        <div className="lenis-wrapper">
        <div  className="min-h-screen bg-[#222222] flex items-center justify-center py-20 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 bg-[#292929] p-10 rounded-xl shadow-lg">
                <div>
                    <h2 className="mt-6 text-center text-4xl font-bold text-white">
                        Crea tu Cuenta
                    </h2>
                    <p className="mt-2 text-center text-sm text-gray-400">
                        Únete y empieza a  disfrutar de nuestros servicios.
                    </p>
                </div>

                <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                        <input name="nombre" type="text" require value={formData.nombre} onChange={handleChange} className="input-field bg-[#222222] px-4" placeholder="Nombre"/>
                        <input name="apellido" type="text" required value={formData.apellido} onChange={handleChange} className="input-field bg-[#222222] px-4" placeholder="Apellido" />
                        <input name="email" type="email" required value={formData.email} onChange={handleChange} className="input-field mt-4 bg-[#222222] px-4" placeholder="Correo Electrónico" />
                        <input name="cedula" type="tel" maxLength='10' required value={formData.cedula} onChange={handleChange} className="input-field mt-4 bg-[#222222] px-4" placeholder="Cédula" />
                        <input name="password" type="password" required value={formData.password} onChange={handleChange} className="input-field mt-4 bg-[#222222] px-4" placeholder="Contraseña" />
                        <input name="telefono" type="tel" maxLength='10' required value={formData.telefono} onChange={handleChange} className="input-field mt-4 bg-[#222222] px-4" placeholder="Teléfono Móvil" />
                

                    <div className="flex items-center">
                        <input 
                            id="aceptaTerminos" 
                            name="aceptaTerminos" 
                            type="checkbox" 
                            checked={formData.aceptaTerminos} 
                            onChange={handleChange} 
                            className="h-4 w-4 text-lime-400 focus:ring-lime-300 rounded bg-gray-700" 
                        />
                        <label htmlFor="aceptaTerminos" className="ml-2 text-sm text-gray-300 flex items-center">
                            Acepto los
                            <button 
                                onClick={() => setIsTermsOpen(true)} 
                                className="ml-1 text-lime-300 hover:text-white inline-flex items-center" 
                                type="button" // Es buena práctica especificar el tipo
                            >
                                Términos y Condiciones
                            </button>
                        </label>
                    </div>

                    <div className="flex flex-col md:flex-row gap-4">
                        <button type="submit" className="form-button bg-lime-400 text-black hover:bg-white hover:text-lime-400">
                            Registrar
                        </button>
                        <button type="button" onClick={handleClear} className="form-button bg-gray-600 text-white hover:bg-gray-500">
                            Limpiar
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <Modal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)}>
                <TermsConditions />
        </Modal>
        </div>
    );
}

export default SignUpPage;
